import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '@shared/services/shared.service';
import { IWaterSystem } from 'app/models/water-systems/water-system';
import { HousingUnitService } from 'app/services/housingunit-service';
import { DialogEditHousingUnitWaterSystemComponent } from './water-system-edit-dialog';
import { MatTableDataSource } from '@angular/material/table';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';



@Component({
  selector: 'water-systems',
  templateUrl: './water-systems.component.html',
  styleUrls: ['./water-systems.component.scss']
})
export class WaterSystemsComponent implements OnInit {
  @Input('housingUnitId')
  housingUnitId: number = 0;
  processing: boolean = false;
  loading: boolean = false;
  
  displayedColumns: string[] = ['id', 'name', 'comment', 'active', 'updated', 'actions'];
  dataSource = new MatTableDataSource<IWaterSystem>();
  pageSize = 10;
  resultSize: number = 0;
  systems: IWaterSystem[] = [];


  constructor(public dialog: MatDialog,
    public housingUnitService: HousingUnitService,
    public authService: AuthService,
    public oregonWellDataService: OregonWellDataService,
    private toastr: ToastrService,
    private sharedService: SharedService) {
  }
  ngOnInit(): void {
   this.load();
  }
 
  load() {
    this.loading = true;
    this.housingUnitService.getHousingUnitWaterSystems(this.housingUnitId).subscribe(
      result => {
        this.systems = result;
        this.dataSource = new MatTableDataSource<IWaterSystem>(result);
        this.resultSize = result.length;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.toastr.error("Unable to load Water Systems");
      }
    );
  }

  add() {
    const dialogRef = this.dialog.open(DialogEditHousingUnitWaterSystemComponent, {
      width: '90%',
      data: {
        id: 0,
        housingUnitId: this.housingUnitId,
        waterSystemId: 0
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });    
  }

  edit(id: number) {
    const dialogRef = this.dialog.open(DialogEditHousingUnitWaterSystemComponent, {
      width: '90%',
      data: {
        id: id,
        housingUnitId: this.housingUnitId,
        waterSystemId: id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });    
  }

  delete(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this water system?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.housingUnitService.deleteHousingUnitWaterSystem(id).subscribe(
          result => {
            this.toastr.success("Water System Removed");
            this.load();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove Water System.");
            this.processing = false;
          }
        );
      }
    });
  } 
}